import React, { Component } from 'react';
import { useForm } from 'react-hook-form';
import $ from "jquery";
import config from "../config";
import {
    ModulesModal,
    SeriesModal,
    ChangePasswordModal,
    AreYouAgreeModal,
    BusinessPartnerFields,
    ItemDataFields,
    MVentasModulesModal
} from "./index";
import ApiClient from '../libs/apiClient';

let apiClient = ApiClient.getInstance();

class MVentasAdminUsersModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            showModulesModal: false,
            auxUserModules: [],
            typeVisibility: true,
        };

    };

    componentDidMount = () => {
        this._handelBack();
        this.GetAdminDeliveriesData();
    };


    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    };

    openAction = () => {
        $('#MVentasAdminUsersModal').on('hide.bs.modal', function () {
        });
    };

    closeModal = () => {
        const { setShowMVentasModal } = this.props
        $('#MVentasAdminUsersModal').modal('hide');

        setShowMVentasModal(false)
    };
    cancelEditMode = () => {
        this.setInitModulesUser();
        this.setEditMode(false);
        this.EyeVisibility();
    }
    setEditMode = (value) => {
        const { detailsData } = this.props;
        if (value) {
            this.setState({
                auxUserModules: detailsData.Modules.slice(),
            })
        }
        this.setState({
            editMode: value,
        });
    };
    onChangeControl = (value) => {
    }
    OpenModulesModal = async () => {
        const { detailsData } = this.props;
        await this.setState({
            showModulesModal: !this.state.showModulesModal,
            auxUserModules: detailsData.Modules.slice(),
        });
        $('#mVentasModulesModal').modal('show');
    };
    CloseModulesModal = async () => {
        $('#mVentasModulesModal').modal('hide');
        await this.setState({
            showModulesModal: !this.state.showModulesModal,

        });
        this.setInitModulesUser();
    };
    setInitModulesUser = () => {
        const { auxUserModules } = this.state
        const { detailsData, setDetailsData } = this.props;
        const auxDetailsData = { ...detailsData }
        auxDetailsData.Modules = auxUserModules
        setDetailsData(auxDetailsData)
        this.setState({
            auxUserModules: []
        })
    }
    SaveModules = async () => {
        $('#mVentasModulesModal').modal('hide');
        await this.setState({
            showModulesModal: !this.state.showModulesModal,

        });
    }
    SelectModule = (module) => {
        const { detailsData, setDetailsData } = this.props;
        const auxDetailsData = { ...detailsData }
        const modulesUser = auxDetailsData.Modules.slice();
        const modActive = module.active == 'Y' ? 'N' : 'Y';
        const indexModule = modulesUser.findIndex((userModule) => userModule.idModule === module.idModule);

        if (indexModule != -1) {
            modulesUser[indexModule].active = modActive
        } else {
            module.active = modActive
            modulesUser.push(module)
        }
        auxDetailsData.Modules = modulesUser
        setDetailsData(auxDetailsData)
    }
    acceptEditMode = () => {
        const { saveUser } = this.props
        saveUser()
    }
    EyeVisibility = async () => {
        const { typeVisibility, editMode } = this.state;
        if (!editMode) return
        this.setState({
            typeVisibility: !typeVisibility
        })
    };

    changeFieldModel = (model, key, value) => {
        const { detailsData, setDetailsData } = this.props;
        const auxDetailsData = JSON.parse(JSON.stringify(detailsData))
        auxDetailsData[key] = value
        setDetailsData(auxDetailsData)
    }
    GetAdminDeliveriesData = async () => {
        const { enableSpinner, showAlert } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.getAdminDeliveriesData();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }

        await this.setState({
            availableDrivers: responseApi.data?.drivers ?? [],
        });
    }

    render() {
        const {
            modules,
            detailsData,
        } = this.props;
        const {
            editMode,
            showModulesModal,
        } = this.state;



        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll no-select"
                id="MVentasAdminUsersModal"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true">
                {showModulesModal &&
                    <MVentasModulesModal
                        modules={modules}
                        editMode={editMode}
                        userModules={detailsData?.Modules ?? []}
                        CloseModulesModal={this.CloseModulesModal}
                        SaveModules={this.SaveModules}
                        selectModule={this.SelectModule}
                    />
                }


                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">{'USUARIO (detalle)'}</h4>
                            <button type="button" className="close" onClick={() => this.closeModal()} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            {this.renderEditButton()}
                                            {this.renderAdminUsersHeader()}
                                            {/* {this.renderAdminUsersBody()} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">


                            {editMode &&
                                <>
                                    <button type="button" className="btn botonCorrect" onClick={this.acceptEditMode}>
                                        Guardar
                                    </button>
                                    <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                        Cancelar
                                    </button>
                                </>
                            }
                            <button type="button" className="btn botonCerrar text-white" onClick={() => this.closeModal()}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
                {this.openAction()}
            </div>
        );
    }
    renderAdminUsersHeader = () => {
        const { detailsData, } = this.props;
        const { editMode, typeVisibility, availableDrivers } = this.state;
        return (
            <div className="row" style={{ paddingRight: 0 }} autoComplete="off">
                {/*PRIMER COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*CÓDIGO DE USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Código</span>
                        </div>
                        <input type="text" className="form-control"
                            id="mVCode"
                            disabled={true}
                            value={detailsData.empID ? detailsData.empID : ""} />
                    </div>
                    {/*NOMBRE*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                        </div>
                        <input type="text" className="form-control"
                            id="mVName"
                            disabled={true}
                            value={detailsData.firstName || "" + "" + detailsData.lastName || ""} />
                    </div>
                    {/*MÓDULOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Módulos</span>
                        </div>
                        <button
                            type="button"
                            style={!editMode ? {} : { backgroundColor: 'transparent', color: '#EABF28' }}
                            disabled={!editMode}
                            className="input-group-text"
                            onClick={() => this.OpenModulesModal()}>
                            <i className="fa fa-list" aria-hidden="true" />
                        </button>
                    </div>
                </div>
                {/*SEGUNDA COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*CORREO DE USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Correo</span>
                        </div>
                        <input type="text" className="form-control"
                            id="mVCode"
                            disabled={!editMode ? true : false}
                            value={detailsData.email ? detailsData.email : ""}
                            onChange={(event) => editMode && this.changeFieldModel(detailsData, "email", event.target.value)} />
                    </div>
                    {/*CONTRASEÑA DE USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Contraseña</span>
                        </div>
                        <input className="form-control"
                            style={!typeVisibility ? { backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' } : {}}
                            type={!typeVisibility ? 'text' : 'password'}
                            disabled={!editMode ? true : false}
                            autoComplete="new-password"
                            value={detailsData.password ? !typeVisibility ? detailsData.password : "*********" : ""}
                            onChange={(event) => editMode && this.changeFieldModel(detailsData, "password", event.target.value)}
                        />
                        <div className="input-group-prepend" style={{ width: 40 }}>
                            <span className="input-group-text" style={{ background: '' }}
                                onClick={() => this.EyeVisibility()}><i className={typeVisibility === false ? 'fa fa-eye' : 'fa fa-eye-slash'} /></span>
                        </div>
                    </div>
                    {/*FIGURA DE TRANSPORTE*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Empleado Entregas</span>
                                <span className="d-inline d-xl-none">Emp.Entr</span>
                            </span>
                        </div>
                        <select
                            name="select"
                            className="form-control"
                            id="selectDocTypeDocumentSearch"
                            disabled={!editMode ? true : false}
                            // style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                            value={detailsData.IdVHCL ? detailsData.IdVHCL : ""}
                            onChange={(event) => this.changeFieldModel(detailsData, "IdVHCL", event.target.value)}
                        >
                            <option value="-1">Selecciona un chofer para entregas</option>
                            {availableDrivers && availableDrivers.map((driver, index) => {
                                return (
                                    <option key={'optionDriver' + index} value={driver.CodigoFiguraTransporte}>{driver.NombreFigura}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>

            </div>);
    }
    renderEditButton = () => {
        const { editMode } = this.state
        if (editMode) return <></>
        if (!editMode) {
            return (
                <button
                    type="button"
                    style={{ backgroundColor: 'transparent', color: '#000' }}
                    className="btn btn-editar"
                    onClick={() => this.setEditMode(true)}>
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            );
        }

    }

}

export default MVentasAdminUsersModal;